module.exports = __webpack_public_path__ + "assets/img/trophy.a2ca97bc.svg";